<template>
  <div
    class="z-10 hidden w-full shrink-0 items-center justify-center bg-white shadow-lg md:flex"
  >
    <div
      v-for="(step, index) in steps"
      :key="`step_${index}`"
      v-memo="[
        mediaclipStore.emptyWorksheets.length,
        step.isActive,
        mediaclipStore.filledWorksheets.length,
        mediaclipStore.amountOfWorksheets,
      ]"
      class="flex items-center"
    >
      <DefaultTooltip
        :content="
          mediaclipStore.emptyWorksheets.length > 0
            ? $tc(
                'pages.configurator.worksheet_container.buttons.next.tooltip.selects_remaining',
                {
                  count: mediaclipStore.emptyWorksheets.length,
                }
              )
            : $tc(
                'pages.configurator.worksheet_container.buttons.next.tooltip.checks_remaining',
                {
                  count:
                    mediaclipStore.amountOfWorksheets -
                    mediaclipStore.filledWorksheets.length,
                }
              )
        "
        :disabled="step.isActive || popperDisable"
      >
        <button
          :class="[
            step.isActive
              ? 'bg-primary text-white'
              : 'bg-gray-lightest transition-colors duration-100 ease-in-out hover:bg-gray-light',
            configuratorStore.hasMediaclipError
              ? 'disabled:cursor-default'
              : mediaclipStore.emptyWorksheets.length
                ? 'disabled:cursor-help disabled:opacity-50'
                : 'disabled:cursor-progress disabled:opacity-70',
          ]"
          :disabled="
            configuratorStore.isUpdatingProject ||
            configuratorStore.hasMediaclipError ||
            (configuratorStore.isSimpleConfigurator &&
              mediaclipStore.emptyWorksheets.length === 1)
          "
          :title="
            configuratorStore.isUploadConfigurator ||
            (configuratorStore.isSimpleConfigurator &&
              (mediaclipStore.emptyWorksheets.length >= 1 ||
                mediaclipStore.filledWorksheets.length !==
                  mediaclipStore.amountOfWorksheets))
              ? step.title
              : undefined
          "
          class="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full transition"
          @click="step.onClick"
        >
          {{ index + 1 }}
        </button>
      </DefaultTooltip>

      <!-- Show separator line between steps -->
      <div
        v-if="index !== steps.length - 1"
        class="mx-4 h-0 w-20 border-b border-white-darker"
      />
    </div>

    <div class="mx-4 hidden h-0 w-20 border-b border-white-darker sm:block" />

    <div
      class="hidden h-8 w-8 items-center justify-center rounded-full sm:flex"
    >
      <ShoppingCartIcon class="h-5 w-5 text-gray-light" />
    </div>
  </div>
</template>

<script setup lang="ts">
import I18n from '@/i18n';
import { useConfiguratorStore } from '@/stores/Configurator/ConfiguratorStore';
import { useMediaclipStore } from '@/stores/Configurator/MediaclipStore';
import { ConfiguratorStep } from '@/types/Configurator/ConfiguratorStep';
import { ShoppingCartIcon } from '@heroicons/vue/24/outline';
import { computed, ref } from 'vue';
import DefaultTooltip from '@/components/Tooltips/DefaultTooltip.vue';

const configuratorStore = useConfiguratorStore();
const mediaclipStore = useMediaclipStore();

const isMobile = ref(window.matchMedia('(max-width: 767px)').matches);

const steps = ref([
  {
    title: I18n.global.t('pages.navigation.header.configurator'),
    isActive: computed(() =>
      [
        ConfiguratorStep.Configurator,
        ConfiguratorStep.HalfConfigurator,
      ].includes(configuratorStore.currentStep)
    ),
    onClick: () => {
      configuratorStore.setConfiguratorStep();
    },
  },
  {
    title: I18n.global.t('pages.navigation.header.extra_options'),
    isActive: computed(
      () => configuratorStore.currentStep === ConfiguratorStep.ExtraOptions
    ),
    onClick: () => {
      configuratorStore.nextStep(isMobile.value);
    },
  },
]);

const popperDisable = computed(() => {
  return (
    configuratorStore.isUploadConfigurator ||
    mediaclipStore.filledWorksheets.length ===
      mediaclipStore.amountOfWorksheets ||
    mediaclipStore.filledWorksheets.length ===
      mediaclipStore.amountOfWorksheets ||
    mediaclipStore.amountOfWorksheets === 0
  );
});
</script>
